import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from './FilterDefinition';
import { FormatFilterOptionValue } from '@studyportals/search-filters/server-side';
import { FilterOptionInformation } from '@studyportals/search-filters';

class FormatFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.ATTENDANCE,
			[
				new FilterOptionInformation('Full-time', FormatFilterOptionValue.FULL_TIME, 'full-time', 'Full-time'),
				new FilterOptionInformation('Part-time', FormatFilterOptionValue.PART_TIME, 'part-time', 'Part-time'),
			],
			[FormatFilterOptionValue.PART_TIME, FormatFilterOptionValue.FULL_TIME],
		);
	}
}

export default new FormatFilterDefinition();
